import React, { useState, useEffect, useMemo } from "react";
import LoaderStyleOne from '../../../components/LoaderStyleOne';
import MUIDataTable from "mui-datatables";
import {
  Box,
  Divider,
  Grid,
  Typography,
  TextField,
  IconButton,
  TableCell,
  //Select,
  //MenuItem,
  Link,
  Tabs,
  Tab,
  Modal,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getData, postData } from "../../../ServerRequest";
import SearchIcon from "@mui/icons-material/Search";
import ViewOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
//import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
//import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import UnarchiveOutlinedIcon from "@mui/icons-material/UnarchiveOutlined";
import BatchCollection from "./BatchCollection";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export default function ProductCollection() {
  const searchParams = new URLSearchParams(window.location.search);
  const collectionId = searchParams.get("collection_id");
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);
  const [collectionData, setCollectionData] = useState([]);
  const [allCollections, setAllCollections] = useState([]); 
  const [liveCollection, setLiveCollectionData] = useState([]);
  const [archivedCollection, setArchivedCollectionData] = useState([]);
  const [deletedCollection, setDeletedCollectionData] = useState([]);
  const [columns, setColumns] = useState();
  const [counts, setCounts] = useState({
    liveCollection: 0,
    archivedCollection: 0,
    deletedCollection: 0,
  });
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCollections, setSelectedCollections] = useState([]);
  const [selectedTag, setSelectedTag] = useState("");
  const [tagsData, setTagsData] = useState([]);
  const [batchAccordionOpen, setBatchAccordionOpen] = useState(false);
  const [tagsModalOpen, setTagsModalOpen] = useState(false);
  const [modalTags, setModalTags] = useState([]);
  const [modalTitle, setModalTitle] = useState("");

  const renderTagsCell = (value, tableMeta) => {
    if (!Array.isArray(value)) return value;
    const idIndex = columns?.findIndex(c => c.name === "id");
    const rowId = idIndex !== -1 ? tableMeta.rowData[idIndex] : tableMeta.rowIndex;
    const tagsToShow = value.slice(0, 4);
    const hiddenCount = value.length - 4;

    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "center" }}>
        {tagsToShow.map((tag, idx) => (
          <div
            key={tag + idx}
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "4px 14px",
              backgroundColor: "#F3F4F6",
              borderRadius: "16px",
              fontSize: "12px",
              color: "#565E6D",
              border: "1px solid #E0E0E0",
              boxShadow: "0 1px 2px rgba(60,60,60,0.04)",
              fontWeight: 500,
              margin: 0,
              minHeight: "28px",
              boxSizing: "border-box",
            }}
          >
            {tag}
          </div>
        ))}
        {hiddenCount > 0 && (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "4px 12px",
              backgroundColor: "#E0E0E0",
              borderRadius: "16px",
              fontSize: "12px",
              color: "#333",
              cursor: "pointer",
              textAlign: "center",
              fontWeight: 600,
              border: "1px solid #BDBDBD",
              minHeight: "28px",
              boxSizing: "border-box",
            }}
            onClick={() => {
              setModalTags(value);
              setTagsModalOpen(true);
              setModalTitle(tableMeta.rowData[0] || "Tags");
            }}
          >
            +{hiddenCount}
          </div>
        )}
      </div>
    );
  };

  const handleSaveArchive = async (row) => {
    setLoading(true);
    try {
      const collectionDataObj = {
        'collection_id': row.id ? row.id : "",
        'collection_status': "archived",
      };
      const res = await postData(
        "/api/product/product-collection",
        collectionDataObj
      );
      if (res["data"]["code"] === "200") {
        const updatedRow = res.data.updated_collection || { ...row, collection_status: "archived" };
        setLiveCollectionData((prev) => prev.filter((item) => item.id !== row.id));
        setArchivedCollectionData((prev) => [updatedRow, ...prev]);
        setCounts((prevCounts) => ({
          ...prevCounts,
          liveCollection: prevCounts.liveCollection - 1,
          archivedCollection: prevCounts.archivedCollection + 1,
        }));
        // If on live tab, update collectionData too
        if (selectedTab === 0) {
          setCollectionData((prev) => prev.filter((item) => item.id !== row.id));
        }
      } else {
        alert("Archive failed");
        console.error("Failed to archive:", res.statusText);
      }
    } catch (error) {
      console.error("Error archiving data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveRetrieve = async (row) => {
    setLoading(true);
    try {
      const collectionDataObj = {
        'collection_id': row.id ? row.id : "",
        'collection_status': "live",
      };
      const res = await postData(
        "/api/product/product-collection",
        collectionDataObj
      );
      if (res["data"]["code"] === "200") {
        const updatedRow = res.data.updated_collection || { ...row, collection_status: "live" };
        setArchivedCollectionData((prev) => prev.filter((item) => item.id !== row.id));
        setLiveCollectionData((prev) => [updatedRow, ...prev]);
        setCounts((prevCounts) => ({
          ...prevCounts,
          archivedCollection: prevCounts.archivedCollection - 1,
          liveCollection: prevCounts.liveCollection + 1,
        }));
        // If on archived tab, update collectionData too
        if (selectedTab === 1) {
          setCollectionData((prev) => prev.filter((item) => item.id !== row.id));
        }
      } else {
        alert("Retrieve failed");
        console.error("Failed to retrieve:", res.statusText);
      }
    } catch (error) {
      console.error("Error retrieving data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveDelete = async (row) => {
    setLoading(true);
    try {
      const collectionDataObj = {
        'collection_id': row.id ? row.id : "",
        'collection_status': "delete",
      };
      const res = await postData(
        "/api/product/product-collection",
        collectionDataObj
      );
      if (res["data"]["code"] === "200") {
        const updatedRow = res.data.updated_collection || { ...row, collection_status: "delete" };
        setLiveCollectionData((prev) => prev.filter((item) => item.id !== row.id));
        setDeletedCollectionData((prev) => [updatedRow, ...prev]);
        setCounts((prevCounts) => ({
          ...prevCounts,
          liveCollection: prevCounts.liveCollection - 1,
          deletedCollection: prevCounts.deletedCollection + 1,
        }));
        // If on live tab, update collectionData too
        if (selectedTab === 0) {
          setCollectionData((prev) => prev.filter((item) => item.id !== row.id));
        }
      } else {
        alert("Delete failed");
        console.error("Failed to delete:", res.statusText);
      }
    } catch (error) {
      console.error("Error deleting data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      setLoading(true);

      let masterRes = await getData("/api/product/acc_tag_master");
      console.log(masterRes);
      let master_data = masterRes["data"]["tag_masters"];
      if (master_data) {
        // Map the data to ensure it contains both id and product_tag
        const formattedData = master_data.map((tag) => ({
          id: tag.id,
          product_tag: tag.product_tag,
        }));
        setTagsData(formattedData);
      } else {
        console.error("Error fetching tags data:", masterRes.message);
      }

      let reqData = await getData("/api/product/product-collection");
      console.log(reqData);
      let collections_data = reqData["data"]["collection_data"];
      let live_collections = reqData["data"]["live_collections"];
      let archived_collections = reqData["data"]["archived_collections"];
      let deleted_collections = reqData["data"]["deleted_collections"];

      if (collections_data) {
        setAllCollections(Array.isArray(collections_data) ? collections_data : []); // Set once
        setCollectionData(Array.isArray(collections_data) ? collections_data : []); // Default to all
        setLiveCollectionData(Array.isArray(live_collections) ? live_collections : []);
        setArchivedCollectionData(Array.isArray(archived_collections) ? archived_collections : []);
        setDeletedCollectionData(Array.isArray(deleted_collections) ? deleted_collections : []);
      } else {
        console.error("Error fetching collections data:", reqData.message);
      }

      setCounts({
        liveCollection: reqData["data"]["live_collection_count"],
        archivedCollection: reqData["data"]["archived_collection_count"],
        deletedCollection: reqData["data"]["deleted_collection_count"],
      });

      setLoading(false);
    }

    fetchData();
  }, [collectionId]);

  const reloadCollections = async () => {
    setLoading(true);
    try {
      let reqData = await getData("/api/product/product-collection");

      let collections_data = reqData["data"]["collection_data"];
      let live_collections = reqData["data"]["live_collections"];
      let archived_collections = reqData["data"]["archived_collections"];
      let deleted_collections = reqData["data"]["deleted_collections"];

      setAllCollections(Array.isArray(collections_data) ? collections_data : []); // Update allCollections too
      setCollectionData(Array.isArray(collections_data) ? collections_data : []);
      setLiveCollectionData(
        Array.isArray(live_collections) ? live_collections : []
      );
      setArchivedCollectionData(
        Array.isArray(archived_collections) ? archived_collections : []
      );
      setDeletedCollectionData(
        Array.isArray(deleted_collections) ? deleted_collections : []
      );
      setCounts({
        liveCollection: reqData["data"]["live_collection_count"],
        archivedCollection: reqData["data"]["archived_collection_count"],
        deletedCollection: reqData["data"]["deleted_collection_count"],
      });
    } catch (error) {
      console.error("Error reloading collections:", error);
    } finally {
      setLoading(false);
    }
  };

  // Enhanced renderSortIcon to always show an icon
  const renderSortIcon = (columnMeta, sortOrder) => {
    // If this column is sorted, highlight the icon
    if (sortOrder && sortOrder.index === columnMeta.index) {
      if (sortOrder.direction === "asc") {
        return (
          <ArrowUpwardIcon
            style={{ fontSize: 16, marginLeft: 4, color: "#333" }}
          />
        );
      }
      if (sortOrder.direction === "desc") {
        return (
          <ArrowDownwardIcon
            style={{ fontSize: 16, marginLeft: 4, color: "#333" }}
          />
        );
      }
    }
    // Not sorted: show faded icon (default to up arrow)
    return (
      <ArrowUpwardIcon style={{ fontSize: 16, marginLeft: 4, color: "#ccc" }} />
    );
  };

  const allColumns = [
    {
      name: "collection",
      label: "Collection Name",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
              minWidth: 180,
              width: 180,
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", fontWeight: 700, minWidth: 180, width: 180 },
        }),
      },
    },

    {
      name: "promotional_name",
      label: "Promotional name",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
              minWidth: 180,
              width: 180,
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", minWidth: 180, width:180 },
        }),
      },
    },

    {
      name: "product_count",
      label: "No of items",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
              minWidth: 120, // <-- increased width
              width: 140, // <-- increased width
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", minWidth: 120, width: 140 }, // <-- increased width
        }),
      },
    },

    {
      name: "tag_name",
      label: "Tags",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value, tableMeta) => renderTagsCell(value, tableMeta),
      },
    },

    {
      name: "collection_status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },

    {
      name: "id", // Use 'id' as the column for the action value
      label: "Action",
      options: {
        sort: false,
        customHeadRender: (columnMeta) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        customBodyRender: (value, tableMeta) => {
          const rowId = value;
          // For View action, only check All and Live tabs
          const row = allCollections.find((r) => r.id === rowId);
          return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
              <Link
                style={{
                  color: "black",
                  fontWeight: "bold",
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                }}
                href={`/admin/products/collectionMaster/collectionItems?collection_id=${rowId}`}
              >
                <IconButton>
                  <ViewOutlinedIcon
                    style={{ color: "black", width: "20px", height: "20px" }}
                  />
                </IconButton>
              </Link>
            </div>
          );
        },
      },
    },
  ];

  const liveColumns = [
    {
      name: "collection",
      label: "Collection Name",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
              minWidth: 180,
              width: 180,
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", fontWeight: 700, minWidth: 180, width: 180 },
        }),
      },
    },

    {
      name: "promotional_name",
      label: "Promotional name",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
              minWidth: 180,
              width: 180,
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", minWidth: 180, width:180 },
        }),
      },
    },

    {
      name: "product_count",
      label: "No of items",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
              minWidth: 120, // <-- increased width
              width: 140, // <-- increased width
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", minWidth: 120, width: 140 }, // <-- increased width
        }),
      },
    },

    {
      name: "tag_name",
      label: "Tags",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value, tableMeta) => renderTagsCell(value, tableMeta),
      },
    },

    {
      name: "id", // Use 'id' as the column for the action value
      label: "Action",
      options: {
        sort: false,
        customHeadRender: (columnMeta) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        customBodyRender: (value, tableMeta) => {
          const rowId = value;
          // Find the row from the correct collection array based on the current tab
          let row;
          if (selectedTab === 1) {
            row = liveCollection.find((r) => r.id === rowId);
          } else if (selectedTab === 2) {
            row = archivedCollection.find((r) => r.id === rowId);
          } else {
            row = deletedCollection.find((r) => r.id === rowId);
          }
          return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", gap: "10px" }}>
              <Link
                style={{
                  color: "black",
                  fontWeight: "bold",
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                }}
                href={`/admin/products/collectionMaster/collectionItems?collection_id=${rowId}`}
              >
                <IconButton>
                  <ViewOutlinedIcon
                    style={{ color: "black", width: "20px", height: "20px" }}
                  />
                </IconButton>
              </Link>
              <IconButton
                style={{ color: "black" }}
                onClick={async () => {
                  if (row) await handleSaveArchive(row);
                }}
              >
                <ArchiveOutlinedIcon
                  style={{ color: "black", width: "20px", height: "20px" }}
                />
              </IconButton>
              <IconButton
                style={{ color: "black" }}
                onClick={async () => {
                  if (row) await handleSaveDelete(row);
                }}
              >
                <DeleteOutlinedIcon
                  style={{ color: "black", width: "20px", height: "20px" }}
                />
              </IconButton>
            </div>
          );
        },
      },
    },
  ];

  const archivedColumns = [
    {
      name: "collection",
      label: "Collection Name",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
              minWidth: 180,
              width: 180,
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", fontWeight: 700, minWidth: 180, width: 180 },
        }),
      },
    },

    {
      name: "promotional_name",
      label: "Promotional Name",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
              minWidth: 180,
              width: 180,
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", minWidth: 180, width: 180 },
        }),
      },
    },

    {
      name: "product_count",
      label: "No of items",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
              minWidth: 120, // <-- increased width
              width: 140, // <-- increased width
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", minWidth: 120, width: 140 }, // <-- increased width
        }),
      },
    },

    {
      name: "tag_name",
      label: "Tags",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value, tableMeta) => renderTagsCell(value, tableMeta),
      },
    },

    {
      name: "id",
      label: "Retrieve",
      options: {
        sort: false,
        customHeadRender: (columnMeta) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        customBodyRender: (value, tableMeta) => {
          const rowId = value;
          // Find the row from archivedCollection by id
          const rowToRetrieve = archivedCollection.find((r) => r.id === rowId);
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%"
              }}
            >
              <IconButton
                style={{ color: "black" }}
                onClick={async () => {
                  if (rowToRetrieve) await handleSaveRetrieve(rowToRetrieve);
                }}
              >
                <UnarchiveOutlinedIcon
                  style={{ color: "black", width: "20px", height: "20px" }}
                />
              </IconButton>
            </div>
          );
        },
      },
    },
  ];

  const deletedColumns = [
    {
      name: "collection",
      label: "Collection Name",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
              minWidth: 160,
              width: 160,
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", fontWeight: 700, minWidth: 160, width: 160 },
        }),
      },
    },

    {
      name: "promotional_name",
      label: "Promotional Name",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
              minWidth: 180,
              width: 180,
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", minWidth: 180, width: 180 },
        }),
      },
    },

    {
      name: "product_count",
      label: "No of items",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
              minWidth: 120, // <-- increased width
              width: 140, // <-- increased width
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", minWidth: 120, width: 140 }, // <-- increased width
        }),
      },
    },

    {
      name: "tag_name",
      label: "Tags",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value, tableMeta) => renderTagsCell(value, tableMeta),
      },
    },
  ];

  const getActiveOptions = () => ({
    elevation: 0,
    filterType: "checkbox",
    responsive: "standard",
    tableBodyHeight: "calc(100vh - 64px - 48px)",
    tableBodyMaxHeight: "calc(100vh - 64px - 48px)",
    print: false,
    download: false,
    columns: false,
    viewColumns: false,
    filter: false,
    search: false,
    textLabels: {
      body: {
        noMatch: loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
            <LoaderStyleOne />
          </div>
        ) : "Sorry, no matching records found",
      },
    },
    selectableRows: "multiple",
    onTableChange: (action, state) => {
      if (action === "rowsSelect") {
        const selectedIndexes = state.selectedRows.data.map(
          (row) => row.dataIndex
        );
        const selectedCollections = selectedIndexes.map(
          (index) => filteredData[index]
        );
        setSelectedRows(selectedCollections);
        // Open the batch accordion if any row is selected
        setBatchAccordionOpen(selectedCollections.length > 0);
        console.log("Row selection changed:", selectedCollections);
      }
    },
  });

  const getArchiveOptions = () => ({
    ...getActiveOptions(),
  });

  const getDeleteOptions = () => ({
    ...getActiveOptions(),
  });

  const getAllOptions = () => ({
    ...getActiveOptions(),
  });

  useEffect(() => {
    if (selectedTab === 0) {
      setCollectionData(Array.isArray(allCollections) ? allCollections : []); // Always use allCollections for All tab
      setColumns(allColumns);
    } else if (selectedTab === 1) {
      setCollectionData(liveCollection);
      setColumns(liveColumns);
    } else if (selectedTab === 2) {
      setCollectionData(archivedCollection);
      setColumns(archivedColumns);
    } else {
      setCollectionData(deletedCollection);
      setColumns(deletedColumns);
    }
  }, [selectedTab, allCollections, liveCollection, archivedCollection, deletedCollection]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setSearchQuery("");
  };

  // Filtered data based on searchQuery and selectedTag
  const filteredData = useMemo(() => {
    // Ensure collectionData is always an array
    const safeCollectionData = Array.isArray(collectionData)
      ? collectionData
      : [];
    let data = safeCollectionData;

    if (selectedTag) {
      data = data.filter((row) => row.product_tags?.includes(selectedTag));
    }

    if (searchQuery) {
      data = data.filter((row) =>
        Object.values(row || {}).some((value) =>
          typeof value === "object"
            ? Object.values(value || {}).some((subValue) =>
                subValue
                  ?.toString()
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase())
              )
            : value
                ?.toString()
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
        )
      );
    }

    // Sort by created date descending if available, else by id descending
    return [...data].sort((a, b) => {
      if (a.created_at && b.created_at) {
        return new Date(b.created_at) - new Date(a.created_at);
      }
      if (a.id && b.id) {
        return b.id - a.id;
      }
      return 0;
    });
  }, [collectionData, searchQuery, selectedTag]);

  //Batch delete
  const handleDeleteRows = (collectionsToDelete) => {
    setSelectedRows((prevRows) =>
      prevRows.filter((row) => !collectionsToDelete.includes(row.id))
    );
    setSelectedCollections((prevCollections) =>
      prevCollections.filter(
        (collection) => !collectionsToDelete.includes(collection.id)
      )
    );
  };

  const handleToggleRow = (collectionName) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows.some(
        (row) => row.collection === collectionName
      );

      if (isSelected) {
        // Remove the collection if it's already selected
        return prevSelectedRows.filter(
          (row) => row.collection !== collectionName
        );
      } else {
        // Add the collection if it's not selected
        const collectionToAdd = collectionData.find(
          (row) => row.collection === collectionName
        );
        return [...prevSelectedRows, collectionToAdd];
      }
    });
  };

  // Handler to reload collections and clear selection after batch update
  const handleBatchUpdate = async () => {
    await reloadCollections();
    setSelectedRows([]);
    setSelectedCollections([]);
  };

  return (
    <Box sx={{ width: "95%", paddingLeft: 3, mb: 5 }}>
      <Grid container sx={{ flex: 1, height: "100%" }}>
        <Box sx={{ width: "100%", height: "100%" }}>
          {/* View collection Section */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 0,
              mb: 2,
            }}
          >
            <Typography
              variant="body1"
              sx={{ font: "Inter", fontWeight: 700, fontSize: 17 }}
            >
              Collection master
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              mt: 4,
              mb: 2,
            }}
          >
            {/* Tabs Section */}
            <Box sx={{ height: "36px" }}>
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                variant="fullWidth"
                sx={{
                  minHeight: "35px",
                  border: "1px solid #F3F4F6",
                  borderRadius: "0px",
                  "& .MuiTabs-flexContainer": {
                    height: "35px",
                  },
                  "& .MuiTab-root": {
                    minHeight: "35px",
                    width: "144px",
                    borderRight: "1px solid #F3F4F6",
                    textTransform: "none",
                    color: "#333",
                  },
                  "& .MuiTab-root:last-of-type": {
                    borderRight: "none",
                  },
                  "& .Mui-selected": {
                    color: "#000 !important",
                  },
                  "& .MuiTabs-indicator": {
                    height: "3px !important",
                    backgroundColor: "#9095A0 !important",
                  },
                }}
              >
                <Tab label={`All (${allCollections.length})`} />
                <Tab label={`Live (${counts.liveCollection})`} />
                <Tab label={`Archived (${counts.archivedCollection})`} />
                <Tab label={`Deleted (${counts.deletedCollection})`} />
              </Tabs>
            </Box>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              ml: "auto",
              mb: 2,
            }}
          >
            <Box sx={{ flex: 1, display: "flex", justifyContent: "start" }}>
              {/* Search Box */}
              <TextField
                sx={{
                  mr: 20,
                  "& .MuiOutlinedInput-root": {
                    height: "35px",
                    width: "435px",
                    borderRadius: "0px",
                  },
                }}
                size="small"
                variant="outlined"
                placeholder="Search by collection, tags..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <IconButton
                      position="start"
                      sx={{ ml: "-10px", mr: 1, color: "black" }}
                    >
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
            </Box>
            {/* <Select 
                            sx={{ width: "167px", height: "35px", borderRadius: "0px" }}
                            size="small" 
                            variant="outlined"       
                            value={selectedTag}
                            onChange={(e) => setSelectedTag(e.target.value)} // Update selectedTag state                           
                        > 
                            {tagsData.map(tag => (
                                <MenuItem key={tag.tag_id} value={tag.product_tag}>
                                    {tag.product_tag}
                                </MenuItem>
                            ))}
                        </Select>                       
                        <Select
                            sx={{ width: "167px", height: "35px", borderRadius: "0px" }}
                            size="small" 
                            variant="outlined" 
                        />    */}
          </Box>

          {/* Data Table */}
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
              <LoaderStyleOne />
            </div>
          ) : (
            <Box
              sx={{
                border: "1px solid #F4F3F6",
                '& div[class*="MUIDataTableToolbar"]': { display: "none" },
              }}
            >
              <MUIDataTable
                title={""}
                data={filteredData}
                columns={columns ? columns : allColumns}
                options={
                  selectedTab === 0
                    ? getAllOptions()
                    : selectedTab === 1
                    ? getActiveOptions()
                    : selectedTab === 2
                    ? getArchiveOptions()
                    : getDeleteOptions()
                }
              />
            </Box>
          )}

          {/* Batch Action Collapsible */}
          <BatchCollection
            selectedRows={selectedRows}
            selectedCollections={selectedCollections}
            onDeleteRows={handleDeleteRows}
            onToggleRow={handleToggleRow}
            onBatchUpdate={handleBatchUpdate}
            expanded={batchAccordionOpen}
            setExpanded={setBatchAccordionOpen}
          />
        </Box>

        <Modal
          open={tagsModalOpen}
          onClose={() => setTagsModalOpen(false)}
          sx={{ fontFamily: "Inter" }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 0,
              minWidth: 320,
              maxWidth: 400,
              outline: "none",
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="body1" sx={{ fontWeight: 700, fontSize: 16 }}>
                {modalTitle} - Tags
              </Typography>
              <IconButton
                aria-label="close"
                onClick={() => setTagsModalOpen(false)}
                sx={{ color: '#565E6D' }}
                size="small"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px", mt: 4 }}>
              {modalTags.map((tag, idx) => (
                <div
                  key={tag + idx}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "4px 14px",
                    backgroundColor: "#F3F4F6",
                    borderRadius: "16px",
                    fontSize: "12px",
                    color: "#565E6D",
                    border: "1px solid #E0E0E0",
                    boxShadow: "0 1px 2px rgba(60,60,60,0.04)",
                    fontWeight: 500,
                    margin: 0,
                    minHeight: "28px",
                    boxSizing: "border-box",
                  }}
                >
                  {tag}
                </div>
              ))}
            </Box>
          </Box>
        </Modal>
      </Grid>
    </Box>
  );
}
